import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllPointageHistory } from "../../Services/Pointeuse/PointageApi";
import { getAllSettings } from "../../Services/Pointeuse/SettingsApi";
import { getUsersActifByCode, getUsersByCode } from "../../Services/Pointeuse/UsersApi";
import CustomSyncLoader from "../Others/CustomSyncLoader";
import ErrorCustum from "../Others/ErrorCustum";
import ButtonHeaderComponent from "../Styles/ButtonHeaderComponent";
import ImageComponent from "../Styles/ImageComponent";
import AddPointage from "./AddPointage";
import SingleMonthPointage from "./SingleMonthPointage";
import PointageStaticMonth from "./PointageStaticMonth";

var dateObj = new Date();
var result = dateObj.toISOString().split("T")[0];
var month = result.split("-")[1];
var year = result.split("-")[0];
var newdate = year + "-" + month;

function PointageMonth() {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [date, setdate] = useState(newdate);

  const [dataPointages, setDataPointages] = useState(null);

  /**
   * It gets the data from the API and sets the data to the state.
   */
  const getData = () => {
    setLoading(true);
    getUsersByCode()
      .then((res) => {
        setdata(res.data);
        console.log(res.data);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getData();
  }, []);

  /**
   * The function takes in a date and sets the date state to that date
   * @param date - The date that the user has selected.
   */
  const handleChangeDate = (date) => {
    setLoading(true);
    setdate(date);
    setLoading(false);
  };

  useEffect(() => {
    getAllPointageHistory().then((res) => {
      setDataPointages(res.data);
    });
  }, []);

  return (
    <div>
      <div className="page-header d-xl-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">{t("Pointage")}</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className="d-flex align-items-end flex-wrap my-auto right-content breadcrumb-right">
            <div className="btn-list">
              <Link to="#" className="btn btn-primary mr-3" data-toggle="modal" data-target="#addPointageModal">
                {t("Pointage")}
              </Link>
              {/* <ButtonHeaderComponent /> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12 col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 col-lg-3">
                  <div className="form-group">
                    <label className="form-label">{t("Choisir le moins")}:</label>
                    <div className="input-group" >
                      <div className="input-group-prepend">
                        <div className="input-group-text">
                          <i className="feather feather-calendar" />
                        </div>
                      </div>
                      <input
                        className="form-control fc-datepicker"
                        placeholder="DD-MM-YYYY"
                        type="month"
                        onChange={(e) => handleChangeDate(e.target.value)}
                      />
                    </div>
                  
                    {/* <div>
                  <li>
                      <a href="#tab13" data-toggle="tab">
                        {t("Pointage par mois Par Collaborateur")}
                      </a>
                    </li>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="d-flex mb-6 mt-5">
                <div className="mr-3">
                  <label className="form-label">{t("Note")}:</label>
                </div>
                <div>
                  <span className="badge badge-success-light mr-2">
                    <i className="feather feather-check-circle text-success" /> {t("présent")}
                  </span>
                  <span className="badge badge-danger-light mr-2">
                    <i className="feather feather-x-circle text-danger" /> {t("absent")}
                  </span>

                  <span className="badge badge-warning-light mr-2">
                    <i className="feather feather-x-circle text-warning" /> {t("non pointage sortie")}
                  </span>
                  {/* <span className="badge badge-orange-light mr-2">
                    <i className="fa fa-star text-orange" /> jour férié
                  </span>
                  <span className="badge badge-secondary-light mr-2">
                    <i className="fa fa-calendar text-secondary" /> congé
                  </span> */}

                  <span className="badge badge-primary-light mr-2">
                    <i className="fa fa-adjust text-primary" /> {t("encours")}
                  </span>
                  <span className="badge badge-success-light mr-2">
                    <i className="fa fa-calendar text-success" /> {t("weekend")}
                  </span>
                </div>
              </div>
              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive hr-attlist">
                  <table className="table  table-vcenter text-nowrap table-bordered border-top border-bottom" id="hr-attendance">
                    <thead>
                      <tr>
                        <th className="border-bottom-0">{t("nom/prénom")}</th>
                        <th className="border-bottom-0 w-5">1</th>
                        <th className="border-bottom-0 w-5">2</th>
                        <th className="border-bottom-0 w-5">3</th>
                        <th className="border-bottom-0 w-5">4</th>
                        <th className="border-bottom-0 w-5">5</th>
                        <th className="border-bottom-0 w-5">6</th>
                        <th className="border-bottom-0 w-5">7</th>
                        <th className="border-bottom-0 w-5">8</th>
                        <th className="border-bottom-0 w-5">9</th>
                        <th className="border-bottom-0 w-5">10</th>
                        <th className="border-bottom-0 w-5">11</th>
                        <th className="border-bottom-0 w-5">12</th>
                        <th className="border-bottom-0 w-5">13</th>
                        <th className="border-bottom-0 w-5">14</th>
                        <th className="border-bottom-0 w-5">15</th>
                        <th className="border-bottom-0 w-5">16</th>
                        <th className="border-bottom-0 w-5">17</th>
                        <th className="border-bottom-0 w-5">18</th>
                        <th className="border-bottom-0 w-5">19</th>
                        <th className="border-bottom-0 w-5">20</th>
                        <th className="border-bottom-0 w-5">21</th>
                        <th className="border-bottom-0 w-5">22</th>
                        <th className="border-bottom-0 w-5">23</th>
                        <th className="border-bottom-0 w-5">24</th>
                        <th className="border-bottom-0 w-5">25</th>
                        <th className="border-bottom-0 w-5">26</th>
                        <th className="border-bottom-0 w-5">27</th>
                        <th className="border-bottom-0 w-5">28</th>
                        <th className="border-bottom-0 w-5">29</th>
                        <th className="border-bottom-0 w-5">30</th>
                        <th className="border-bottom-0 w-5">31</th>
                        <th className="border-bottom-0">Total</th>
                      </tr>
                    </thead>
                    {dataPointages && (
                      <tbody>
                        {data.map((el, idx) => (
                          <SingleMonthPointage user={el} currentDate={date} dataPointages={dataPointages} />
                        ))}
                      </tbody>
                    )}

                    <tfoot>
                      <tr>
                        <th className="border-bottom-0">{t("nom/prénom")}</th>
                        <th className="border-bottom-0 w-5">1</th>
                        <th className="border-bottom-0 w-5">2</th>
                        <th className="border-bottom-0 w-5">3</th>
                        <th className="border-bottom-0 w-5">4</th>
                        <th className="border-bottom-0 w-5">5</th>
                        <th className="border-bottom-0 w-5">6</th>
                        <th className="border-bottom-0 w-5">7</th>
                        <th className="border-bottom-0 w-5">8</th>
                        <th className="border-bottom-0 w-5">9</th>
                        <th className="border-bottom-0 w-5">10</th>
                        <th className="border-bottom-0 w-5">11</th>
                        <th className="border-bottom-0 w-5">12</th>
                        <th className="border-bottom-0 w-5">13</th>
                        <th className="border-bottom-0 w-5">14</th>
                        <th className="border-bottom-0 w-5">15</th>
                        <th className="border-bottom-0 w-5">16</th>
                        <th className="border-bottom-0 w-5">17</th>
                        <th className="border-bottom-0 w-5">18</th>
                        <th className="border-bottom-0 w-5">19</th>
                        <th className="border-bottom-0 w-5">20</th>
                        <th className="border-bottom-0 w-5">21</th>
                        <th className="border-bottom-0 w-5">22</th>
                        <th className="border-bottom-0 w-5">23</th>
                        <th className="border-bottom-0 w-5">24</th>
                        <th className="border-bottom-0 w-5">25</th>
                        <th className="border-bottom-0 w-5">26</th>
                        <th className="border-bottom-0 w-5">27</th>
                        <th className="border-bottom-0 w-5">28</th>
                        <th className="border-bottom-0 w-5">29</th>
                        <th className="border-bottom-0 w-5">30</th>
                        <th className="border-bottom-0 w-5">31</th>
                        <th className="border-bottom-0">{t("Total")}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddPointage getData={getData} />
    </div>
  );
}

export default PointageMonth;
